import React from 'react'
import {
  SidebarMenuButton,
  SidebarMenuButtonProps,
} from './sidebar-menu-button'

export type SidebarItemIdExtended = string | number

export interface SidebarMenuItem<SidebarItemId extends SidebarItemIdExtended> {
  id: SidebarItemId
  label: SidebarMenuButtonProps['label']
  icon?: SidebarMenuButtonProps['icon']
}

export interface SidebarMenuProps<
  SidebarItemId extends SidebarItemIdExtended,
  MenuItem extends
    SidebarMenuItem<SidebarItemId> = SidebarMenuItem<SidebarItemId>,
> {
  menuItems: MenuItem[]
  selectedItem: SidebarItemId
  onSelect: (item: SidebarItemId) => void
}

export const SidebarMenu = <SidebarItemId extends SidebarItemIdExtended>({
  menuItems,
  selectedItem,
  onSelect,
}: SidebarMenuProps<SidebarItemId>) => {
  return (
    <div className="flex flex-col gap-2">
      {menuItems.map(item => (
        <SidebarMenuButton
          key={item.id}
          label={item.label}
          icon={item.icon}
          onChange={() => onSelect(item.id)}
          checked={selectedItem === item.id}
        />
      ))}
    </div>
  )
}
